// Reading what a driver typed into the employer search before it is sent.
//
// The server does the forgiving part — spellings, aliases, ranking — so only
// two questions are answered here, because the sheet has to act on them before
// any response: is this a DOT number, and is this an employer at all?

export { parseDotNumberQuery } from 'src/components/Inputs/CarrierAutocomplete/dotNumberQuery'

// What drivers typed as an employer for time they were not working: "Na",
// "N/A", "No", "Unemployment". Matched whole, after punctuation is dropped, so
// "Nash Trucking" or "None Such LLC" are never caught.
const GAP_WORDS = new Set([
  'NA',
  'N A',
  'NO',
  'NONE',
  'NOTHING',
  'NOT APPLICABLE',
  'UNEMPLOYED',
  'UNEMPLOYMENT',
  'NOT EMPLOYED',
  'NOT WORKING',
  'NO JOB',
  'NO EMPLOYER',
  'LAID OFF',
  'BETWEEN JOBS',
  'STUDENT',
  'SCHOOL',
  'DISABILITY',
  'DISABLED',
  'RETIRED',
  'STAY AT HOME',
  'HOMEMAKER',
  'MEDICAL LEAVE',
  'INCARCERATED',
])

/** True when the query reads as time between jobs rather than an employer. */
export const isGapLikeQuery = (query: string): boolean => {
  const normalized = query
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, ' ')
    .trim()
  return GAP_WORDS.has(normalized)
}
